import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import '../../BusinessInfo/css/BusinessInfo.css';
import Page from '../img/Building.png';
import design1 from '../img/sotec_img_design_1.png';
import design2 from '../img/sotec_img_design_2.png';
import design3 from '../img/sotec_img_design_3.png';
import Text from '../../../common/Text.js';


// 사업소개 (리뉴얼) - 설계
function Building() {

    
  useEffect(() => {


    const options = {
        // null을 설정하거나 무엇도 설정하지 않으면 브라우저 viewport가 기준 .
        root: null,
        // 타겟 요소의 50%가 루트 요소와 겹치면 콜백을 실행
        threshold: 0.5

    };


        // Intersection Observer 인스턴스
        const observer = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv1');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims = document.querySelectorAll(".Cont1_1")

        ims.forEach(img =>
            observer.observe(img)
        );
    

        // Intersection Observer 인스턴스
        const observer2 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv2');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims2 = document.querySelectorAll(".Cont1_2")

        ims2.forEach(img =>
            observer2.observe(img)
        );
    


        // Intersection Observer 인스턴스
        const observer3 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv3');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims3 = document.querySelectorAll(".Cont1_3")

        ims3.forEach(img =>
            observer3.observe(img)
        );

        

        // Intersection Observer 인스턴스
        const observer4 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv4');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims4 = document.querySelectorAll(".box1_img")

        ims4.forEach(img =>
            observer4.observe(img)
        );

        
        // Intersection Observer 인스턴스
        const observer5 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv5');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims5 = document.querySelectorAll(".box2_img")

        ims5.forEach(img =>
            observer5.observe(img)
        );
    

        
        // Intersection Observer 인스턴스
        const observer6 = new IntersectionObserver(function (entries, observer) {
            entries.forEach(entry => {
                
                if (entry.isIntersecting) {
                    entry.target.classList.add('testDiv6');

                }
                else {
                    console.log('벗어남')
                }
            })
        }, options)


        const ims6 = document.querySelectorAll(".box3_img")

        ims6.forEach(img =>
            observer6.observe(img)
        );
    
    
    

      }, [])





     return ( 
        <div class = 'groupa' style={{display:'flex', justifyContent : 'center'}}>

         
        
        <div class="page"> 


        {/* <div class="imgtxt"> 
            <img class="imgs_B"  src={Page} />
            <Text variant='titlename_B' className='Title_B'>설계</Text>
        </div> */}



        <div class="Cont_1" > 

            <div class="Cont1_1" > 
            <Text  variant="px32w700B" className='MidTitle'>조선해양산업의 미래를 설계하는 정밀 엔지니어링 기술</Text>    
            </div>
            
            <div class="Cont1_2" > 
            <Text  variant="px28w400"  className='SmallTitle'>조선업 성장의 핵심으로서 완벽한 설계를 보장하는 정밀 엔지니어링 기술을 제공합니다.</Text>
            </div>

            <div class="Cont1_3" > 
            <Text variant="px20w400" className='Contents'>선박의 구조설계와 의장설계를 통해 안정성과 내구성을 책임지는 종합 솔루션을 제공합니다. 구조설계는 생산성과 안정성을 극대화하며, 의장설계는 효율적인 공간 활용과 최적화된 배치를 통해 고객의 요구를 100% 반영합니다. 
            풍부한 경험과 기술력을 바탕으로 선박의 가치와 품질을 극대화하는 전문역량을 갖추고 있습니다.</Text>
            </div>

        </div>


        <div class="boxFrame">
            
         <Text  variant="px32w700B"  className='MidTitle'>대표 프로젝트</Text>

        <div class="Contents_GRP">

            <div class="box1">
                <div class="box1_img" >
                    <img class="proj_img"  src={design1} />
                </div>
                <div class="box1_child" >
                    <Text variant="px24w600_B" className='proj_nm'>3D Modeling</Text>
                    <Text variant="px18w400_B" className='proj_nm_Cnts'>형태를 시각적으로 표현함으로써 이해와 검토가 용이해지고 설계 오류를 사전에 예방하여 품질을 향상시킵니다.</Text>
                </div>
              
            </div>
            
            <div class="box2">
                 
                <div class="box2_child" >

                     <Text variant="px24w600_B" className='proj_nm'>해상 시운전 및 중/경사 시험</Text>
                     <Text variant="px18w400_B" className='proj_nm_Cnts'>시운전 경사시험 중사시험을 통해 선박의 성능과 운항 안전성을 평가하는 필수적인 역할을 하고 있습니다.</Text>
                </div>

                <div class="box2_img" >
                    <img class="proj_img2"  src={design2} />
                </div>

            </div>

             <div class="box3">
                
                 <div class="box3_img" >
                    <img class="proj_img3"  src={design3} />
                 </div>

                 <div class="box3_child">
                    <Text variant="px24w600_B" className='proj_nm'>GUI 모델링·구조해석</Text>
                    <Text variant="px18w400_B" className='proj_nm_Cnts'>구조 해석, 유체 역학, 열 해석 등을 수행할 수 있습니다. 직관적인 GUI를 통해 복잡한 모델링과 해석을 쉽게 수행할 수 있습니다.</Text>
                    </div>

            </div>  

            </div>

        </div>
        

        </div >
         {/* <img class="page"  src={Page1} ></img> */}


         </div>
     );
 }
 
 export default Building;
